// extracted by mini-css-extract-plugin
module.exports = {"badge":"ManagedBadge_badge__j0xY6"};